var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.688L1.682 0 10 8.333l-8.318 8.334L0 14.979l6.63-6.646z",
    fill: "#0079BC"
  })));
};

export default SvgArrow;